import * as React from 'react';
import * as mui from '@mui/material';
import * as icons from '@mui/icons-material';

const defaultRegExp = /^(.{0}|.{0,19})$/;

interface TextFieldProps {
	value: string;
	setValue: React.Dispatch<React.SetStateAction<string>>;
	startIcon?: React.ReactNode;
	placeholder: string;
	regexp?: RegExp;
	errorMessage?: String;
	StackProps?: mui.StackProps;
}

const TextField = (props: TextFieldProps) => {
	const { value, setValue, startIcon, placeholder, regexp, errorMessage, StackProps } = props;
	const [valueValidation, setValueValidation] = React.useState((regexp || defaultRegExp).test(value));

	const handleOnChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const newValue = event.target.value;

		setValue(newValue);
		setValueValidation((regexp || defaultRegExp).test(newValue));
	};

	return (
		<mui.Stack {...StackProps} sx={{ maxWidth: 300, ...StackProps?.sx }}>
			<mui.Stack direction='row' alignItems='center' spacing={1} sx={{ py: 1, px: 2, backgroundColor: 'background.default', borderRadius: 3 }}>
				{startIcon}

				<mui.InputBase
					placeholder={placeholder}
					inputProps={{ 'aria-label': placeholder }}
					onChange={handleOnChange}
					value={value}
					sx={{
						flex: 1,
						typography: 'body2',
						color: valueValidation ? 'text.primary' : 'error.main',
						'&, & > *': { border: 'none!important' },
					}}
				/>

				{!valueValidation && <icons.Error color='error' />}
			</mui.Stack>

			{!valueValidation && errorMessage !== undefined && (
				<mui.Typography variant='body2' color='error.dark' sx={{ fontWeight: 'bold' }}>
					{errorMessage}
				</mui.Typography>
			)}
		</mui.Stack>
	);
};

export default TextField;
